import { FilterContextType } from "@/types/FilterContext";
import { i18n } from "@/i18n";
import { FilterGroup } from "@/components/FilterSidebar/types";
import { RouteId } from "@/routes/getRoute";

type FilterContextMeta = Record<
  FilterContextType,
  {
    title: string;
    path: RouteId;
    getFilterGroups?: () => FilterGroup[];
    descriptionTransKey?: string;
  }
>;

export const FilterContextMeta: Partial<FilterContextMeta> = {
  bulkMessages: {
    title: i18n.t("studentsList.backToContext.bulkMessages"),
    path: "bulkMessaging",
    descriptionTransKey: "studentsList.contextDescription.bulkMessages",
  },
  funnelChart: {
    title: i18n.t("studentsList.backToContext.funnelChart"),
    path: "funnel",
  },
  feedPosts: {
    title: i18n.t("studentsList.backToContext.feedPosts"),
    path: "feedPosts",
    descriptionTransKey: "studentsList.contextDescription.feedPosts",
  },
  communityTools: {
    title: i18n.t("studentsList.backToContext.communityTools"),
    path: "communityTools",
    descriptionTransKey: "studentsList.contextDescription.communityTools",
  },
  liveEvents: {
    title: i18n.t("studentsList.backToContext.gamesAndLiveEvents"),
    path: "gamesAndLiveEvents",
    descriptionTransKey: "studentsList.contextDescription.gamesAndLiveEvents",
  },
};
